@if (charts.length > 0) {
  <div class="main-container" [style.height.px]="height">
    @for (chart of charts; track chart) {
      <div [style.width.px]="chart.width" [style.height.px]="chart.height">
        @if (canDownload) {
          <button type="button" mat-mini-fab color="primary" (click)="downloadImage(chart.key)" class="button-action">
            <mat-icon>archive</mat-icon>
          </button>
        }
        <h3>{{ chart.title }}</h3>
        <!-- <p> {{chart.key}} </p> -->
        <canvas class="charts" [hidden]="loading" [id]="chart.key">{{ chart.chart }}</canvas>
      </div>
    }
  </div>
}
